import { getDeliveryTypeResp } from 'types/api/response/get-delivery-type-resp'

import { api } from './api'

export const getDeliveryType = (shipmentId: number) =>
  api.get<getDeliveryTypeResp>(`shipments/${shipmentId}`)
